import React from 'react'
import ReactDOM from 'react-dom'
import jQuery from 'lib/jquery'
import { App, $ } from 'frontend/common-imports'
import RoomPageBase from './room-page-base'
import MrsJezebelSchedule from 'frontend/pages/rooms/mrs-jezebel-schedule'
import MrsJezebelOnlineSchedule from 'frontend/pages/rooms/mrs-jezebel-online-schedule'
import conversinSet from 'frontend/lib/conversion/conversion-set'
import moment from 'lib/moment-timezone-custom'
import Glide, { Breakpoints, Controls, Swipe, Images, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import Reviews from 'frontend/pages/rooms/reviews'
import MediaQuery from 'lib/media-query'

class AwardsSlider {
  constructor ({ selector }) {
    this.selector = selector
    this.sliderElement = $(selector)
    this.initIntersectionObserver()
  }

  initIntersectionObserver () {
    this.intersectionObserver = new IntersectionObserver(entries => {
      entries[0].intersectionRatio <= 0 ? this.handleOffScreen() : this.handleOnScreen()
    })
    this.intersectionObserver.observe(this.sliderElement)
  }

  handleOnScreen () {
    console.debug('AwardsSlider#handleOnScreen')
    if (this.enteredScreen !== true) {
      MediaQuery.addListener(() => this.handleMediaQuery())
    }

    this.enteredScreen = true
    this.handleMediaQuery()
  }

  handleOffScreen () {
    console.debug('AwardsSlider#handleOffScreen')
    this.enteredScreen = false
    this.unmount()
  }

  handleMediaQuery () {
    if (!this.enteredScreen) { return }

    if (MediaQuery.current.fits('xlarge')) {
      this.unmount()
    } else {
      this.mount()
    }
  }

  async mount () {
    if (this.glide) { return }

    console.debug('AwardsSlider#mount', 'mounting')

    this.glide = new Glide(this.selector,
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'slider',
          focusAt: 'center',
          startAt: 2,
          perView: 4,
          breakpoints: {
            480: { perView: 2 },
            768: { perView: 3 }
          },
          autoplay: 500,
          lazyGlide: { processImages: true }
        }
      )
    ).mount({ Images, Swipe, Lazy, Breakpoints })
  }

  unmount () {
    if (!this.glide) { return }

    console.debug('AwardsSlider#unmount', 'destroying')
    this.glide.destroy()
    this.glide = null
  }
}

export default class MrsJezebelPage extends RoomPageBase {
  static initSchedule () {
    const {
      roomId,
      openedFrom,
      prebookingCodeOnly,
      onlineVersion
    } = document.body.dataset

    const root = document.getElementById('room_schedule_react')

    if (root) {
      ReactDOM.render(
        React.createElement(
          onlineVersion ? MrsJezebelOnlineSchedule : MrsJezebelSchedule,
          {
            roomId: parseInt(roomId),
            openedFrom: openedFrom && moment(openedFrom),
            prebookingCodeOnly: prebookingCodeOnly !== undefined
          }
        ),
        root
      )
    } else {
      console.log(
        'MrsJezebelPage.initSchedule()',
        'No #room_schedule_react element. Looks like booking not opened.'
      )
    }
  }

  static initModalVideo () {
    console.debug('MrsJezebelPage.initModalVideo()')
    const roomVideo = document.getElementById('room_video')

    jQuery('#video_modal').on('open.zf.reveal', () => {
      App.lazyLoad.observe()
      console.debug('MrsJezebelPage.initModalVideo():', 'open.zf.reveal')
      roomVideo.play().catch((error) => {
        console.error(
          'MrsJezebelPage.initModalVideo():', 'open.zf.reveal', 'video.play() failed', error
        )
      })
    })

    jQuery('#video_modal').on('closed.zf.reveal', () => {
      roomVideo.pause()
    })
  }

  static selectSlide (ev) {
    if (!ev.target.dataset.slide) { return }

    this.targetSlide = ev.target.dataset.slide
  }

  static handleRevealOpen () {
    if (this.revealSlider) {
      this.targetSlide &&
        setTimeout(() => {
          this.revealSlider.go(`=${this.targetSlide}`)
        }, 500)
    } else {
      this.initRevealSlider()
    }
  }

  static initRevealSlider () {
    if (this.revealSlider) { return this.revealSlider }

    this.revealSlider = new Glide('.modal_images_slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          focusAt: 'center',
          perView: 1,
          startAt: this.targetSlide || 0,
          lazyGlide: Object.assign(GLIDE_SETTINGS.lazyGlide, { processImages: true })
        }
      )
    ).mount({ Swipe, Controls, Images, Lazy })
  }

  static popupSlider () {
    console.debug('MrsJezebelPage.popupSlider()')
    jQuery('#images_modal').on('open.zf.reveal', () => this.handleRevealOpen())
    document.querySelector('.thumbnails').addEventListener('click', (ev) => this.selectSlide(ev))
  }

  static mobileSlider () {
    console.debug('MrsJezebelPage.mobileSlider()')

    new Glide('.images_slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'slider',
          focusAt: 'center',
          perView: 1
        }
      )
    ).mount({ Swipe, Controls, Images, Lazy })
  }

  static handleDOMReady () {
    this.initModalVideo()
    this.initSchedule()
    this.awardsSlider = new AwardsSlider({ selector: '.awards_list' })

    conversinSet.push({ event: 'viewItem', item: document.body.dataset.roomId })
  }

  static handleStylesApplied () {
    this.onEnter('.thumbnails', () => this.popupSlider())
    this.onEnter('.images_slider', () => this.mobileSlider())
    Reviews.init()
  }
}

MrsJezebelPage.init()
